/**
 * Extra fields for `CopyOptionsModalConfirmClicked`.
 *
 * @param {object|null|undefined} convertingParams
 * @returns {{ transformation_mode?: string, presets: object }}
 */
export default function copyOptionsModalAnalytics(convertingParams) {
  const params = convertingParams && typeof convertingParams === 'object'
    ? convertingParams
    : {};

  const mode = params.transformationMode;
  let transformation_mode;
  if (mode === 'resize') transformation_mode = 'Resize';
  else if (mode === 'crop') transformation_mode = 'Crop';

  const presets = { ...params };
  const w = Number(params.width);
  const h = Number(params.height);
  if (Number.isFinite(w)) presets.resize_width = w;
  if (Number.isFinite(h)) presets.resize_height = h;

  return {
    ...(transformation_mode ? { transformation_mode } : {}),
    presets,
  };
}
